export default "__VITE_ASSET__CzH4Q0o8__"